import { CircularProgress, Grid } from '@mui/material';

export const Loading = () => {
  return (
    <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>
      <CircularProgress />
    </Grid>
  );
};
